import React from 'react';

import CustomButton from '../../CustomButton';
import { MdOutlineLogin } from 'react-icons/md';
import { AiOutlineClose } from 'react-icons/ai';
import { handleLogin, handleRegistration } from '../../auth/apiAuth';
import logo from '../../../../assets/logo/Copy of Hire-Panther_B-01.png';
interface ReusableModalProps {
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}

const MessageModal: React.FC<ReusableModalProps> = ({
  isOpen,
  title,
  children,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleLoginMethod = () => {
    try {
      handleLogin();
    } catch (err) {
      console.error('Logout failed', err);
    }
  };

  const handleRegi = () => {
    try {
      handleRegistration();
    } catch (err) {
      console.error('Registration failed', err);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 shadow-lg ">
      <div className="bg-white text-gray-800 rounded-md max-w-xl w-full shadow-lg p-6 relative ">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-zinc-800 hover:text-red-600 "
          onClick={onClose}
        >
          {/* × */}
          <AiOutlineClose size={16} />
        </button>

        {/* Title */}
        <div className="flex flex-col justify-center items-center mt-8">
          <img
            src={logo}
            alt="Logo"
            className="w-32 sm:w-40 md:w-48 lg:w-56 h-auto mb-2"
          />
          <h2 className="text-xl sm:text-xl font-bold mb-4 text-gray-600 text-center">
            {title}
          </h2>
        </div>

        {/* Content */}
        <div className="text-sm max-h-72 overflow-y-auto space-y-3">
          {children}
        </div>

        {/* Actions */}
        <CustomButton
          label="Login"
          fullWidth
          color="primary"
          radius="sm"
          size="md"
          onPress={handleLoginMethod}
          className="text-md font-semibold mt-5 mb-3"
          endContent={<MdOutlineLogin />}
        />
        <CustomButton
          label="Register"
          fullWidth
          color="primary"
          radius="sm"
          size="md"
          onPress={handleRegi}
          className="text-md font-semibold  mb-3"
          variant="bordered"
        />
      </div>
    </div>
  );
};

export default MessageModal;
